// extracted by mini-css-extract-plugin
module.exports = {"StatusWrapper":"AssignStatus__StatusWrapper___3y4xr"};